import { HEADERS } from 'src/constants/headers';
import { ITemplate } from 'src/interfaces/templates';
import {
    ConversationFactory,
    TemplateSendFactory,
} from 'src/modules/conversations/factories';
import { buildCurrentTemplate } from 'src/modules/conversations/helpers/buildCurrentTemplate';
import { applyChannelSender } from 'src/modules/conversations/channels';
import {
    TActionDeps,
    TSendTemplateDraft,
} from 'src/modules/assistant/actions/types';

export type TLeadTemplateSend = ReturnType<
    typeof TemplateSendFactory.createForLead
>;

/**
 * Loads the draft template and builds its send payload for the lead, with the
 * channel sender when the area config gives none. Null when the lead store is
 * not populated.
 */
export const buildLeadTemplateSend = async (
    draft: TSendTemplateDraft,
    { api, lead, user, channel }: TActionDeps
): Promise<TLeadTemplateSend | null> => {
    const conversation = ConversationFactory.createFromLead(lead);
    if (!conversation) return null;
    const response = await api.get(
        `/templatesTwilio/${draft.templateId}`,
        HEADERS()
    );
    const template = buildCurrentTemplate(
        response.data.data as ITemplate,
        conversation,
        user
    );
    return applyChannelSender(
        TemplateSendFactory.createForLead(template, conversation, user),
        channel
    );
};
